import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';

import { RegistrationBasicElement } from "../models/RegistrationBasicModel";
import { environment } from '../../environments/environment';

  ///import { environment } from '../../../environments/environment';
//   private apiUrl = environment.apiUrl;

@Injectable()
export class RegistrationBasicService {

   /// import { environment } from '../../../environments/environment';
   private apiUrl = environment.apiUrl;

constructor(private http: HttpClient) { }



  addDailyUsedForMobile(app :RegistrationBasicElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  return this.http.post(""+this.apiUrl+"/RegistrationBasic/AddAdmissionMasterIdItemIdDailyUsedForMobile",
  JSON.stringify(app),
  httpOptions
  //  return this.http.post(""+this.apiUrl+"/RegistrationBasic/AddRegistrationBasic",
  )
  }
  GetAllAdmissionMasterIdItemIdDailyUsedData( mid:number ) {
  var httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
        'key': 'x-api-key',
        'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

    })
};
  return this.http.get(""+this.apiUrl+"/Bill/GetAllAdmissionMasterIdItemIdDailyUsed?AdmissionMasterId="+mid,httpOptions);
  }
  GetAllAttendanceRegisterDetailsData( mid:number ) {
  var httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
        'key': 'x-api-key',
        'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

    })
};
  return this.http.get(""+this.apiUrl+"/Bill/GetAllAttendanceRegisterDetails?AdmissionMasterId="+mid,httpOptions);
  }


  /////////////////////////////  ------------- CURD -----------------  /////////////////////

  addRegistrationBasicData(objj:RegistrationBasicElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    //  http://localhost:49587/
    return this.http.post(""+this.apiUrl+"/RegistrationBasic/AddRegistrationBasic",
  //  http://localhost:8080/
  
  /// return this.http.post('http://localhost:58782/api/RegistrationBasic/AddRegistrationBasic',
  JSON.stringify(objj),
  httpOptions

  )
  }
  addDOBToAgeData(objj:RegistrationBasicElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  return this.http.post(""+this.apiUrl+"/RegistrationBasic/AddDOBToAge",
  JSON.stringify(objj),
   httpOptions
  )
  }
  addRegWelcomeMessage(objj:RegistrationBasicElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
   //return this.http.post('"+this.apiUrl+"/RegistrationBasic/AddRegGenerateOTP',
  return this.http.post(""+this.apiUrl+"/RegistrationBasic/AddRegWelcomeMessage",
  JSON.stringify(objj),
   httpOptions
  )
  }
  addRegWelcomeSMS( invoiceno : string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
   //return this.http.post('"+this.apiUrl+"/RegistrationBasic/AddRegGenerateOTP',

   return this.http.get(""+this.apiUrl+"/RegistrationBasic/AddRegWelcomeSMS?InvoiceNo="+invoiceno,httpOptions);

  // return this.http.get("http://adminapinew.thenugabest.com:57597/api/RegistrationBasic/AddRegWelcomeSMS?InvoiceNo="+invoiceno,httpOptions);

  // return this.http.post('"+this.apiUrl+"/RegistrationBasic/AddRegWelcomeSMS',
  // JSON.stringify(objj),
  //  httpOptions
  // )


  }
  addGenerateOTPData(objj:RegistrationBasicElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  return this.http.post(""+this.apiUrl+"/RegistrationBasic/AddRegGenerateOTP",
  //return this.http.post('http://adminapinew.thenugabest.com:57597/api/RegistrationBasic/AddRegGenerateOTP',
  JSON.stringify(objj),
   httpOptions
  )
  }
  addValidateOTPData(objj:RegistrationBasicElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  // return this.http.post('"+this.apiUrl+"/RegistrationBasic/AddRegValidateOTP',
  return this.http.post(""+this.apiUrl+"/RegistrationBasic/AddRegValidateOTP",
  JSON.stringify(objj),
   httpOptions
  )
  }

  
  getAllAdmissionDetailsStatusData() {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/RegistrationBasic/GetAllAdmissionDetailsStatus",httpOptions);
  }

  getAllAdmissionMasterCategoryData() {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/RegistrationBasic/GetAllAdmissionMasterCategory",httpOptions);
  }

  getAllAdmissionMasterCategorySubData( mids : number) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/RegistrationBasic/GetAllAdmissionMasterCategorySub?AdmissionMasterCategoryIds="+mids,httpOptions);
  }




  getAllRegistrationBasicByMIDData( mids : number) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/RegistrationBasic/GetAllRegistrationBasicByMID?MID="+mids,httpOptions);
  }

  

  getAllRegistrationAdditionalByMIDData( mids : number) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/RegistrationBasic/GetAllRegistrationAdditionalByMID?MID="+mids,httpOptions);
  }
 
 




  getAllRegistrationBasicData( today:string , createdbys :number , cido :number ,csido :number , ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/RegistrationBasic/GetAllRegistrationBasic?todays="+today+"&createdby="+createdbys+"&cid="+cido+"&csid="+csido,httpOptions);
  }


   /////////////////////////  ------------  GET ALL ------------   //////////////////////////



   /////////////////////////  ------------  GET ALL ------------   //////////////////////////


  
   DuplicacyCheckForContactNOData( cno : string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/RegistrationBasic/DuplicacyCheckForContactNO?ContactNo="+cno,httpOptions);
  }


  
  addAdmissionDetailsHandleByData(  AdmissionMasterIds :number, CreatedBys :number, Opearations :number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/RegistrationBasic/AddAdmissionDetailsHandleBy?AdmissionMasterId="+AdmissionMasterIds+"&CreatedBy="+CreatedBys+"&Opearation="+Opearations,httpOptions);
  }

  


  //  string frdt , string todt , int Category , int CreatedBy
  getAllAdmissionNEWData( frdt:string, todt:string, Category:number , CreatedBy:number , ZoneId:number , AreaId:number , CategoryId:string  ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    
  return this.http.get(""+this.apiUrl+"/RegistrationBasic/PrintAllAdmissionNEW?frdt="+frdt+"&todt="+todt+"&Category="+Category+"&CreatedBy="+CreatedBy+"&ZoneId="+ZoneId+"&AreaId="+AreaId+"&CategoryId="+CategoryId,httpOptions);

  //return this.http.get("http://localhost:49587/api/RegistrationBasic/PrintAllAdmissionNEW?frdt="+frdt+"&todt="+todt+"&Category="+Category+"&CreatedBy="+CreatedBy+"&ZoneId="+ZoneId+"&AreaId="+AreaId+"&CategoryId="+CategoryId,httpOptions);

  

  }


  PrintAllAttendanceDailyUpdateData( frdt:string, todt:string, Category:number , CreatedBy:number,MachineUsed:string  ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
  return this.http.get(""+this.apiUrl+"/RegistrationBasic/PrintAllAttendanceDailyUpdate?frdt="+frdt+"&todt="+todt+"&Category="+Category+"&CreatedBy="+CreatedBy+"&MachineUsed="+MachineUsed,httpOptions);

  //return this.http.get("http://localhost:49587/api/RegistrationBasic/PrintAllAttendanceDailyUpdate?frdt="+frdt+"&todt="+todt+"&Category="+Category+"&CreatedBy="+CreatedBy+"&MachineUsed="+MachineUsed,httpOptions);


  }


  
  addAdmissionDetailsCategorizeData( AdmissionCategorizeId :number, AdmissionMasterIds :number, CreatedBys :number,  Categorizes : string , Opearations :number ,  Notes: string  ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };

  
  // return this.http.get("http://localhost:49587/api/RegistrationBasic/AddAdmissionDetailsCategorize?AdmissionCategorizeId="+AdmissionCategorizeId+"&AdmissionMasterId="+AdmissionMasterIds+"&CreatedBy="+CreatedBys+"&Categorize="+Categorizes+"&Opearation="+Opearations+"&Notes="+Notes,httpOptions);
      
  
  return this.http.get(""+this.apiUrl+"/RegistrationBasic/AddAdmissionDetailsCategorize?AdmissionCategorizeId="+AdmissionCategorizeId+"&AdmissionMasterId="+AdmissionMasterIds+"&CreatedBy="+CreatedBys+"&Categorize="+Categorizes+"&Opearation="+Opearations+"&Notes="+Notes,httpOptions);
      
  //  return this.http.get(""+this.apiUrl+"/RegistrationBasic/AddAdmissionDetailsCategorize?AdmissionMasterId="+AdmissionMasterIds+"&CreatedBy="+CreatedBys+"&Categorize="+Categorizes+"&Opearation="+Opearations+"&Notes="+Notess,httpOptions);
    
  }
  
  addZoneAreaData(  ZoneId :number, CreatedBys :number,  Name : string , Operation :number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
     //  http://localhost:49587/

    // return this.http.get("http://localhost:49587/api/RegistrationBasic/AddZoneArea?ZoneId="+ZoneId+"&CreatedBy="+CreatedBys+"&Name="+Name+"&Operation="+Operation,httpOptions);


   return this.http.get(""+this.apiUrl+"/RegistrationBasic/AddZoneArea?ZoneId="+ZoneId+"&CreatedBy="+CreatedBys+"&Name="+Name+"&Operation="+Operation,httpOptions);


  }
  
  addAdmissionDetailsFamilyBackgroundData(  AdmissionFamilyBackgroundId :number, FamilyBackground:string ,  AdmissionMasterId :number,  CreatedBy : number , Operation :number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
    
  return this.http.get(""+this.apiUrl+"/RegistrationBasic/AddAdmissionDetailsFamilyBackground?AdmissionFamilyBackgroundId="+AdmissionFamilyBackgroundId+"&FamilyBackground="+FamilyBackground+"&AdmissionMasterId="+AdmissionMasterId+"&CreatedBy="+CreatedBy+"&Operation="+Operation,httpOptions);

  // return this.http.get("http://localhost:49587/api/RegistrationBasic/AddAdmissionDetailsFamilyBackground?AdmissionFamilyBackgroundId="+AdmissionFamilyBackgroundId+"&FamilyBackground="+FamilyBackground+"&AdmissionMasterId="+AdmissionMasterId+"&CreatedBy="+CreatedBy+"&Operation="+Operation,httpOptions);


  }
 
  GetAllAdmissionMasterProspectiveListData(   AdmissionMasterId :number,  CreatedBy : number , Operation :number  ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
    
  return this.http.get(""+this.apiUrl+"/RegistrationBasic/GetAllAdmissionMasterProspectiveList?AdmissionMasterId="+AdmissionMasterId+"&CreatedBy="+CreatedBy+"&Operation="+Operation,httpOptions);

  // return this.http.get("http://localhost:49587/api/RegistrationBasic/AddAdmissionDetailsFamilyBackground?AdmissionFamilyBackgroundId="+AdmissionFamilyBackgroundId+"&FamilyBackground="+FamilyBackground+"&AdmissionMasterId="+AdmissionMasterId+"&CreatedBy="+CreatedBy+"&Operation="+Operation,httpOptions);


  }

  getAllData(   frdt:string, todt:string, Category:string , CreatedBy:number   ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    

  return this.http.get(""+this.apiUrl+"/RegistrationBasic/PrintAllInquirerAppointmentQueue?frdt="+frdt+"&todt="+todt+"&Category="+Category+"&CreatedBy="+CreatedBy,httpOptions);

 // return this.http.get("http://localhost:49587/api/RegistrationBasic/PrintAllInquirer?frdt="+frdt+"&todt="+todt+"&Category="+Category+"&CreatedBy="+CreatedBy,httpOptions);


  }



}
